<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <b-form-row class="mb-3">
          <b-col md="2">
            <label>{{$t('STARTDATE')}}</label>
              <lb-vue-datetimepicker
                  type="date"
                  v-model="filters.startDate"
                  :translate-method="translateDateTimePicker"
                  format="YYYY-MM-DD"
                  display-format="DD.MM.YYYY"
                  :simple="true">
              </lb-vue-datetimepicker>
          </b-col>
          <b-col md="2">
            <label>{{$t('ENDDATE')}}</label>
              <lb-vue-datetimepicker
                  type="date"
                  v-model="filters.endDate"
                  :translate-method="translateDateTimePicker"
                  format="YYYY-MM-DD"
                  display-format="DD.MM.YYYY"
                  :simple="true">
              </lb-vue-datetimepicker>
          </b-col>
          <b-col md="2">
            <label>{{$t('PAYMENTTYPE')}}</label>
            <b-form-input v-model="filters.paymentType" />
          </b-col>
          <b-col md="2">
            <label>{{$t('CREATEDBYUSER')}}</label>
            <b-form-input v-model="filters.createdByUser" />
          </b-col>
        </b-form-row>
        <div class="row">
          <div class="card-body table-logoped" v-if="response.root != null">
            <grid
                :data="response.root"
                ref="invoicesGrid"
                v-model="pagination"
                :columns="columns"
                :totalCount="response.totalCount"
                gridId="fakturkoInvoicesGrid">
              <template v-slot="{item, column}">
                <template v-if="column.id == 'pdfLink'">
                  <a
                      v-if="item.pdfLink"
                      :href="item.pdfLink"
                      target="_blank"
                      rel="noopener noreferrer">
                    {{$t('VIEW_PDF')}}
                  </a>
                </template>
                <template v-if="column.id == 'actions'">
                  <button
                      type="button"
                      class="btn btn-primary btn-sm button-save"
                      @click="showDetail(item)">
                    {{$t('VIEW')}}
                  </button>
                </template>
              </template>
            </grid>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="detailModal" :title="$t('DETAILS')" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block" v-if="selectedItem">
        <div class="row mb-3">
          <div class="col-md-4">
            <strong>{{$t('FAKTURKO_INVOICE_ID')}}:</strong>
            <p>{{selectedItem.fakturkoInvoiceId}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('EXTERNAL_INVOICE_ID')}}:</strong>
            <p>{{selectedItem.externalInvoiceId}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('CREATEDBYUSER')}}:</strong>
            <p>{{selectedItem.createdByUser}}</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <strong>{{$t('AMOUNT')}}:</strong>
            <p>{{formatAmount(selectedItem.amount)}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('PAYMENTTYPE')}}:</strong>
            <p>{{selectedItem.paymentType}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('THERAPYTYPE')}}:</strong>
            <p>{{selectedItem.therapyType}}</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <strong>{{$t('KPD')}}:</strong>
            <p>{{selectedItem.kpd}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('CREATEDAT')}}:</strong>
            <p>{{formatDate(selectedItem.createdAt)}}</p>
          </div>
          <div class="col-md-4">
            <strong>{{$t('PDF')}}:</strong>
            <p>
              <a
                  v-if="selectedItem.pdfLink"
                  :href="selectedItem.pdfLink"
                  target="_blank"
                  rel="noopener noreferrer">
                {{$t('VIEW_PDF')}}
              </a>
              <span v-else>—</span>
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/fakturko_invoices/FakturkoInvoices';

export default
{
    name: 'FakturkoInvoicesWin',
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    key: 'fakturkoInvoiceId',
                    name: me.$t('FAKTURKO_INVOICE_ID'),
                },
                {
                    key: 'externalInvoiceId',
                    name: me.$t('EXTERNAL_INVOICE_ID'),
                },
                {
                    key: 'createdByUser',
                    name: me.$t('CREATEDBYUSER'),
                },
                {
                    key: 'amount',
                    name: me.$t('AMOUNT'),
                    handler(item)
                    {
                        return parseFloat(item.amount).toFixed(2);
                    },
                },
                {
                    key: 'paymentType',
                    name: me.$t('PAYMENTTYPE'),
                },
                {
                    key: 'therapyType',
                    name: me.$t('THERAPYTYPE'),
                },
                {
                    key: 'kpd',
                    name: me.$t('KPD'),
                },
                {
                    key: 'createdAt',
                    name: me.$t('CREATEDAT'),
                    handler(item)
                    {
                        return moment(item.createdAt).format('DD.MM.YYYY HH:mm');
                    },
                },
                {
                    id: 'pdfLink',
                    name: me.$t('PDF'),
                    handler()
                    {
                        return '';
                    },
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            response: {},
            selectedItem: null,
            searchTimeout: false,
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 25,
                sort: 'createdAt',
                dir: 'desc',
            },
            filters:
            {
                startDate: null,
                endDate: null,
                paymentType: '',
                createdByUser: '',
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    computed:
    {
        getParams()
        {
            const me = this;
            const data = {
                ...me.pagination,
                ...me.filters,
            };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;
                me.debouncedGetData();
            },
        },
        filters:
        {
            deep: true,
            handler()
            {
                const me = this;
                me.debouncedGetData();
            },
        },
    },
    methods:
    {
        translateDateTimePicker(val)
        {
            const me = this;
            return me.$t(val.toUpperCase());
        },
        debouncedGetData()
        {
            const me = this;
            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }
            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
        async getData()
        {
            const me = this;
            try
            {
                const data = await Api.selectRow(me.getParams);
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.response = data;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        showDetail(item)
        {
            const me = this;
            me.selectedItem = item;
            me.$refs.detailModal.show();
        },
        formatDate(value)
        {
            return moment(value).format('DD.MM.YYYY HH:mm');
        },
        formatAmount(value)
        {
            return parseFloat(value).toFixed(2);
        },
    },
};
</script>
